import React, { useEffect } from 'react';

import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { SlLEContext } from '../../global-constants';
import { SlStreakGoalScreen } from '../../../../shared/public/SlStreakGoalScreen/SlStreakGoalScreen';
import { Container, StreakService } from '../../../../symphony';

export function StreakGoalScreen() {
	const { actions$ } = Container.take(SlLEContext, SlActions);
	const { configuration$ } = Container.take('global', StreakService);

	const { goalConfig } = configuration$.value;

	useEffect(() => {
		actions$.next({
			type: ActionType.OnStreakGoalScreenMount,
			requestType: RequestType.Parallel,
		});
	}, []);

	const onClick = (value: number): void => {
		actions$.next({
			type: ActionType.OnStreakGoalScreenButtonClick,
			requestType: RequestType.Parallel,
			data: {
				numberValue: value,
			},
		});
	};

	return (
		goalConfig && (
			<SlStreakGoalScreen goalConfig={goalConfig} onClick={onClick} />
		)
	);
}
